// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
	$(document).ready(function () {
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd';
		$('#CheckIn').datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$('#CheckOut').datepicker('setDate', newDate);
				$('#CheckOut').datepicker('option', 'minDate', selectedDate);
			},
		});
		$('#CheckOut').datepicker({
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
		});
	});

	window.onload = function () {
		// ANCHOR (LENIS) FROM URL PARAMETER
		(() => {
			const urlScrolTo = window.location.search.split('&').find((param) => param.includes('scrollTo')) || '';
			const urlScrolToSelector = urlScrolTo.includes('=') ? urlScrolTo.split('=')[1] : '';

			if (urlScrolToSelector) {
				document.querySelectorAll('[data-scrollFromUrl]').forEach((mod) => {
					if (mod.dataset.scrollfromurl === urlScrolToSelector && lenis) {
						lenis.scrollTo(mod, { duration: 0.6, lock: true, offset: -120 });
					}
				});
			}
		})();

		// SELECT ELEMENT FROM URL HASH AND CLICK IT ON PAGE LOAD
		document.querySelectorAll('.js-clickFromURLhash').forEach((link) => {
			if (link.getAttribute('href').includes(window.location.hash) && window.location.hash !== '') {
				link.click();
				/* if (lenis) {
					lenis.scrollTo(link);
				} */
			}
		});

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});
	};

	window.addEventListener('resize', () => {
		updateBtnSvgs();
	});
})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	setStickyBlock('[data-sticky]');
}

// STICKY BLOCKS
function setStickyBlock(selector) {
	const $elements = document.querySelectorAll(selector);
	const headerHeight = document.querySelector('#header').offsetHeight;

	$elements.forEach(($el) => {
		// Create wrapper element
		if (!$el.parentNode.classList.contains('sticky_wrapper')) {
			const $newWrapper = document.createElement('div');
			$newWrapper.setAttribute('data-fromjs', 1);
			$newWrapper.classList.add('sticky_wrapper');
			$el.insertAdjacentElement('beforebegin', $newWrapper);
			$newWrapper.appendChild($el);
		}

		// Set wrapper element
		const $wrapper = $el.parentNode;
		if ($wrapper) {
			//Prevent page jumping
			$wrapper.style.height = `${$el.offsetHeight}px`;
			$el.style.top = `${headerHeight}px`;

			const isSticky = $wrapper.getBoundingClientRect().top < 0 + headerHeight;
			$wrapper.classList.toggle('fixed', isSticky);
		}
	});
}
